// @ts-expect-error ts not available
import { ProgressBar, Step } from "react-step-progress-bar";
import styles from "./BundleBuilderBundle.module.css";
import "react-step-progress-bar/styles.css";
import { useEffect } from "react";
import { BundleTypes, DISCOUNT_TYPES, DiscountTypes, getDiscountValueWithSignString } from "../../constants";

const DiscountIcon = ({ size = 20, color = "#303030" }: { size?: number; color?: string }) => {
    return (
        <svg width={size} height={"auto"} viewBox="0 0 19 20" fill={color} xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.50928 0.77002C9.97158 0.77002 10.3301 0.986363 10.6226 1.27881C10.767 1.42326 10.8982 1.58902 11.02 1.76025L11.3628 2.2749L11.3638 2.27686L11.5884 2.62744C11.664 2.74066 11.7411 2.84891 11.8198 2.94678C11.9785 3.14385 12.1343 3.28682 12.2915 3.35303C12.4471 3.41856 12.6565 3.42587 12.9097 3.39697C13.1607 3.36828 13.4345 3.30656 13.7144 3.24658L14.3101 3.11963C14.5098 3.08374 14.709 3.0594 14.9009 3.05811C15.2905 3.05553 15.6657 3.15102 15.9751 3.46045L16.0815 3.58154C16.3051 3.8733 16.3512 4.21801 16.312 4.5708C16.2678 4.96812 16.1134 5.39437 15.9663 5.79639L15.9653 5.79736C15.8562 6.08504 15.7514 6.37444 15.6919 6.63623C15.6317 6.90097 15.6247 7.11255 15.686 7.26025L15.7505 7.36572C15.8323 7.47282 15.9652 7.58318 16.1411 7.69678C16.3712 7.84539 16.6515 7.98518 16.9302 8.12451H16.9292C17.3116 8.3108 17.7415 8.52064 18.0747 8.79443C18.4114 9.07106 18.6655 9.42632 18.6655 9.90576C18.6655 9.91867 18.664 9.93022 18.6626 9.93799C18.6612 9.9458 18.6593 9.95282 18.6577 9.9585C18.6554 9.96688 18.652 9.97549 18.6499 9.98193C18.6568 10.0017 18.6655 10.0291 18.6655 10.064C18.6655 10.5347 18.4103 10.8859 18.0747 11.1616C17.7423 11.4346 17.3123 11.6488 16.9312 11.8442L16.9282 11.8462C16.6394 11.9856 16.3602 12.1205 16.1333 12.2661C15.9607 12.377 15.831 12.4864 15.7505 12.5972L15.687 12.7075C15.6248 12.8553 15.6315 13.0634 15.6919 13.3267C15.7515 13.5863 15.8568 13.8746 15.9663 14.1733V14.1743L16.0767 14.479C16.1843 14.7871 16.2789 15.1019 16.312 15.3999C16.3511 15.7524 16.3048 16.0966 16.0815 16.3882L15.9751 16.5103C15.6653 16.82 15.2846 16.9152 14.8931 16.9126C14.5069 16.91 14.0958 16.8112 13.7144 16.7231H13.7114C13.4345 16.6539 13.1654 16.592 12.9185 16.5659C12.6705 16.5397 12.4583 16.5512 12.2896 16.6187C12.133 16.6853 11.9778 16.8276 11.8198 17.0239C11.6623 17.2196 11.5128 17.4555 11.3638 17.6938L11.3628 17.6929C11.1562 18.0273 10.9217 18.4022 10.6294 18.6919C10.3343 18.9843 9.97109 19.2007 9.50928 19.2007C9.04699 19.2006 8.68837 18.9836 8.39795 18.688C8.18234 18.4685 7.99881 18.1998 7.8335 17.9341L7.67432 17.6714C7.52506 17.4226 7.38053 17.1827 7.22803 16.9849C7.07438 16.7856 6.92315 16.6434 6.76709 16.5776C6.61172 16.5122 6.39715 16.5043 6.13916 16.5356C5.88396 16.5667 5.60438 16.6342 5.32666 16.7036L5.32568 16.7026C4.9447 16.8003 4.53387 16.9091 4.14795 16.9194C3.80489 16.9286 3.46966 16.8615 3.18311 16.6362L3.06396 16.5298C2.74991 16.2157 2.67726 15.8245 2.71143 15.4224C2.74516 15.0261 2.88416 14.5995 3.01123 14.1987C3.10099 13.8996 3.19248 13.6066 3.24268 13.3413C3.28087 13.1393 3.29144 12.9685 3.26807 12.8325L3.23291 12.7075C3.16934 12.557 3.01885 12.4123 2.79932 12.2651C2.58216 12.1196 2.31871 11.9839 2.04932 11.8442V11.8452C1.67511 11.6581 1.25998 11.4435 0.938965 11.1665C0.61513 10.8871 0.373535 10.5317 0.373535 10.064C0.373558 10.0513 0.375089 10.0404 0.376465 10.0327C0.377916 10.0246 0.379766 10.017 0.381348 10.0112C0.382736 10.0062 0.384761 10.0012 0.38623 9.99658C0.382759 9.9849 0.378734 9.97504 0.377441 9.96729C0.372945 9.94022 0.373535 9.91487 0.373535 9.90576C0.373604 9.4378 0.615449 9.08772 0.938965 8.81104C1.25931 8.53719 1.67536 8.32225 2.04736 8.12646L2.04834 8.12549L2.44287 7.91748C2.56986 7.8481 2.69058 7.77846 2.79932 7.70557C3.01915 7.55821 3.16943 7.41293 3.23291 7.26221C3.29718 7.09961 3.29725 6.88328 3.24951 6.62061C3.20194 6.35898 3.11125 6.07008 3.01221 5.77295L3.01123 5.771C2.88413 5.37014 2.74511 4.94375 2.71143 4.54736C2.67729 4.14535 2.75005 3.75492 3.06396 3.44092L3.18018 3.3374C3.45929 3.1187 3.79034 3.05125 4.13232 3.05811C4.51852 3.06588 4.93432 3.16901 5.32666 3.26709L5.7417 3.36475C5.87811 3.3941 6.01156 3.41954 6.13916 3.43506C6.39715 3.4664 6.61172 3.45751 6.76709 3.39209C6.92309 3.32632 7.07443 3.18503 7.22803 2.98584C7.38062 2.78791 7.52498 2.54723 7.67432 2.29834L7.8335 2.03564C7.99879 1.76996 8.18238 1.50119 8.39795 1.28174C8.68835 0.986143 9.04705 0.770081 9.50928 0.77002ZM9.48975 1.66943C9.28797 1.66943 9.10801 1.77974 8.92334 1.98779C8.73769 2.19699 8.56687 2.48181 8.37646 2.79248C8.04502 3.35782 7.66919 3.97367 7.06885 4.23096H7.06689C6.75176 4.36132 6.4151 4.37528 6.08154 4.33936C5.74953 4.30356 5.4086 4.21652 5.08545 4.13818H5.08154C4.75235 4.0484 4.44791 3.96785 4.18799 3.94678C3.92691 3.92566 3.74401 3.96693 3.62744 4.0835L3.62451 4.08643C3.52754 4.17693 3.49318 4.3437 3.53174 4.61377C3.56938 4.87729 3.66905 5.1925 3.77881 5.53174L3.93701 6.04639C3.98537 6.22088 4.02632 6.39753 4.05322 6.57178C4.10707 6.92075 4.10496 7.27397 3.97412 7.60107L3.97314 7.60205C3.84127 7.92074 3.59754 8.16666 3.31494 8.36963C3.03396 8.57143 2.70336 8.73693 2.38916 8.89404L2.39014 8.89502C2.05939 9.07542 1.755 9.23794 1.53076 9.4126C1.30519 9.5883 1.19404 9.7514 1.19385 9.92529C1.19385 9.93815 1.19231 9.94975 1.19092 9.95752C1.18947 9.9656 1.18762 9.9732 1.18604 9.979C1.18471 9.98385 1.18158 9.9882 1.18018 9.99268C1.18379 10.0047 1.18764 10.015 1.18896 10.0229C1.19343 10.05 1.19385 10.0754 1.19385 10.0845C1.19402 10.2699 1.3073 10.4387 1.53076 10.6128C1.75338 10.7861 2.05646 10.9434 2.38525 11.1128H2.38623C2.70148 11.2704 3.0329 11.4376 3.31494 11.6401C3.59636 11.8423 3.83893 12.0871 3.97119 12.4038H3.97217C4.11571 12.724 4.11745 13.0754 4.06104 13.4243C4.00476 13.7722 3.88758 14.1341 3.77979 14.4771L3.77881 14.479C3.66921 14.8078 3.56932 15.1183 3.53174 15.3813C3.49374 15.6476 3.52573 15.8226 3.62549 15.9243C3.74158 16.0324 3.92506 16.0696 4.18799 16.0483C4.44967 16.0271 4.75492 15.9517 5.08545 15.8716C5.7296 15.696 6.44566 15.5218 7.06689 15.7788H7.06885L7.1792 15.8315C7.71614 16.1133 8.06582 16.6874 8.37646 17.2173L8.65381 17.6567C8.7452 17.793 8.83706 17.9163 8.93115 18.021C9.11947 18.2305 9.29857 18.3403 9.48975 18.3403C9.69241 18.3403 9.8771 18.2291 10.0669 18.0229C10.1621 17.9195 10.2536 17.797 10.3452 17.6636L10.6235 17.2349C10.9554 16.6883 11.3316 16.095 11.9302 15.8384H11.9321L12.0493 15.7944C12.6391 15.6005 13.2888 15.7444 13.894 15.8911C14.223 15.9709 14.5275 16.0411 14.7876 16.0552C15.0485 16.0693 15.2329 16.0245 15.3511 15.9067L15.355 15.9028L15.3872 15.8667C15.4546 15.7734 15.4708 15.6196 15.4263 15.3843C15.3768 15.1228 15.2622 14.8132 15.1421 14.4829V14.48C15.025 14.1385 14.8917 13.7763 14.8228 13.4263C14.7535 13.0747 14.7447 12.7177 14.8882 12.3862C15.021 12.0665 15.2766 11.8217 15.5698 11.6177C15.8632 11.4136 16.2095 11.2402 16.5327 11.0737L16.5347 11.0728L17.0327 10.8218C17.1871 10.7388 17.3275 10.6557 17.4458 10.5718C17.5639 10.4879 17.6538 10.4075 17.7114 10.3306C17.7682 10.2547 17.7895 10.1893 17.7866 10.1304L17.7856 10.1235C17.7857 10.1109 17.7872 10.1 17.7886 10.0923C17.79 10.0843 17.7919 10.0766 17.7935 10.0708C17.795 10.0653 17.7958 10.0592 17.7974 10.0542C17.7943 10.0434 17.7917 10.0341 17.7905 10.0269C17.786 9.99974 17.7856 9.97447 17.7856 9.96533C17.7856 9.79245 17.6707 9.62434 17.4351 9.4458C17.2022 9.26946 16.8824 9.10591 16.5347 8.93701L16.5327 8.93604C16.2096 8.76956 15.8632 8.59712 15.5698 8.39307C15.276 8.18866 15.0199 7.9423 14.8872 7.62158V7.62061C14.7454 7.29106 14.7483 6.93606 14.8149 6.58447C14.8816 6.23303 15.0142 5.87111 15.1421 5.52686L15.311 5.05029C15.3607 4.89894 15.4015 4.75616 15.4263 4.62549C15.4772 4.35654 15.4485 4.19442 15.355 4.10693L15.3511 4.10303C15.2329 3.98525 15.0485 3.94051 14.7876 3.95459C14.5275 3.96865 14.223 4.0389 13.894 4.11865L13.8901 4.11963C13.5675 4.18808 13.2314 4.26437 12.9048 4.29248C12.5761 4.32072 12.2457 4.30116 11.9321 4.17139L11.9292 4.17041C11.6369 4.04052 11.3984 3.82651 11.1909 3.58057C10.9841 3.33538 10.8016 3.05031 10.6245 2.7749H10.6235C10.4334 2.47465 10.2574 2.19376 10.0669 1.98682C9.87711 1.78071 9.6924 1.66946 9.48975 1.66943ZM11.1128 11.3843C10.6916 11.3843 10.3355 11.7404 10.3354 12.1616C10.3354 12.5828 10.6916 12.939 11.1128 12.939C11.5296 12.9388 11.8706 12.6068 11.8901 12.1616L11.8853 12.0835C11.8446 11.6975 11.5075 11.3844 11.1128 11.3843ZM12.2427 7.4624C12.4284 7.32997 12.6802 7.34862 12.8286 7.53662H12.8296C12.8304 7.53744 12.8307 7.53873 12.8315 7.53955C12.8352 7.54426 12.8397 7.54831 12.8433 7.55322H12.8423C12.9239 7.64427 12.9505 7.75823 12.937 7.86279C12.923 7.97145 12.8668 8.07621 12.7808 8.14795L12.7788 8.1499L6.80322 12.8989L6.80127 12.897C6.76202 12.9318 6.71642 12.9543 6.67725 12.9663C6.63274 12.98 6.58533 12.9877 6.54248 12.9878C6.40172 12.9878 6.28223 12.9285 6.19775 12.8159L6.19873 12.814C6.11633 12.7227 6.08949 12.6084 6.10303 12.5034C6.11705 12.3947 6.17319 12.29 6.25928 12.2183L6.26123 12.2163L12.2368 7.46729L12.2427 7.4624ZM7.87061 6.53369C8.24617 6.51459 8.61434 6.62462 8.9165 6.85107L9.04053 6.95459C9.31646 7.20681 9.50502 7.54899 9.56201 7.92529L9.58154 8.09424C9.63387 8.93236 9.03297 9.67877 8.20361 9.80029L8.20264 9.79834C8.10972 9.81953 8.01999 9.82178 7.94678 9.82178C7.16839 9.82178 6.46021 9.23896 6.33154 8.40283V8.40186C6.2671 7.9715 6.37432 7.54014 6.6333 7.19482L6.73584 7.0708C6.98857 6.79428 7.33225 6.6059 7.70947 6.54932L7.87061 6.53369ZM7.93506 7.40869C7.92656 7.41003 7.91654 7.41201 7.90381 7.41455C7.88741 7.41783 7.85803 7.4221 7.82861 7.42432L7.82959 7.42529C7.42255 7.49333 7.12111 7.88426 7.18799 8.30225L7.20361 8.38037C7.30374 8.76032 7.66975 9.00684 8.06396 8.94385C8.4876 8.87607 8.77287 8.48756 8.70557 8.06689V8.06299C8.65523 7.67862 8.31947 7.40779 7.94678 7.40771C7.94677 7.40772 7.94334 7.4074 7.93506 7.40869ZM12.7407 12.3491C12.6569 13.1747 11.9606 13.8177 11.1128 13.8179C10.2083 13.8179 9.47607 13.0857 9.47607 12.1812C9.47627 11.2768 10.2084 10.5444 11.1128 10.5444C11.999 10.5446 12.728 11.2781 12.7495 12.1782V12.1812L12.7407 12.3491Z"
                fill={color}
                stroke={color}
                strokeWidth="0.266"
            />
        </svg>
    );
};

const RenderProgressIcon = ({ accomplished, bar_foreground_color, bar_background_color }: any) => {
    return (
        <span
            className={styles.rewardIcon}
            style={{
                backgroundColor: accomplished ? bar_foreground_color : bar_background_color,
                border: `1px solid ${accomplished ? bar_background_color : bar_foreground_color}`,
                // @ts-expect-error required
                "--icon-size": "27px",
            }}
        >
            <DiscountIcon size={18} color={accomplished ? bar_background_color : bar_foreground_color} />
        </span>
    );
};

const BundleProgressBar = ({
    bundleConfig,
    totalPrice,
    totalQuantity,
    currency,
    money_format,
    tierSuccessMessage,
    actualConfigDiscountType,
    messagePlacement = "top",
}: {
    bundleConfig: any;
    totalPrice: number;
    totalQuantity: number;
    currency: any;
    money_format: any;
    tierSuccessMessage?: string | null;
    actualConfigDiscountType?: DiscountTypes;
    messagePlacement?: "top" | "bottom";
}) => {
    const allDiscountsOptions = [...(bundleConfig?.discount_options || [])];
    const sortedTiers = allDiscountsOptions.sort((a, b) => a.quantity - b.quantity);
    const compareWith = bundleConfig.tier_discount_basis === "bundle_total" ? totalPrice : totalQuantity;

    // Progress percent calculation
    const progressPercent = (() => {
        // Find the current tier position
        let currentTierIndex = -1;
        let nextTierIndex = 0;

        for (let i = 0; i < sortedTiers.length; i++) {
            if (compareWith >= sortedTiers[i].quantity) {
                currentTierIndex = i;
            } else {
                nextTierIndex = i;
                break;
            }
        }

        // If all tiers are completed
        if (currentTierIndex === sortedTiers.length - 1) {
            return 100;
        }

        // Calculate tier positions (starting from 10%)
        const numberOfTiers = sortedTiers.length;

        const getTierPosition = (index: number) => {
            // Special case for 2 tiers: position at 50% and 100%
            if (numberOfTiers === 2) {
                return index === 0 ? 50 : 100;
            }

            // For other cases: Start from 10% and distribute remaining 90% equally
            const startPosition = 10;
            const availableSpace = 90;

            if (numberOfTiers === 1) return 100;
            return startPosition + (availableSpace / (numberOfTiers - 1)) * index;
        };

        // If no tier is accomplished yet, stay before first tier
        if (currentTierIndex === -1) {
            const firstTierPosition = getTierPosition(0);
            const progressToFirstTier = (compareWith / sortedTiers[0].quantity) * firstTierPosition;
            return Math.min(progressToFirstTier, firstTierPosition - 1);
        }

        // If between tiers, calculate progress between current and next tier positions
        if (nextTierIndex < sortedTiers.length) {
            const currentTierPosition = getTierPosition(currentTierIndex);
            const nextTierPosition = getTierPosition(nextTierIndex);
            const currentTierValue = sortedTiers[currentTierIndex].quantity;
            const nextTierValue = sortedTiers[nextTierIndex].quantity;

            const progressInCurrentRange = (compareWith - currentTierValue) / (nextTierValue - currentTierValue);
            const positionInRange =
                currentTierPosition + progressInCurrentRange * (nextTierPosition - currentTierPosition);

            return Math.min(positionInRange, nextTierPosition - 1);
        }

        return 100;
    })();

    // Tiers calculation
    const tiers = sortedTiers.map((option) => {
        const isAccomplished = compareWith >= option.quantity;

        return {
            count: option.quantity,
            type: "discount",
            description: option.TierSuccessMessage,
            accomplished: isAccomplished,
            discountValue: option.discountValue,
            discountType: option.discountType,
            // Calculate position percentage based on tier quantity
            position:
                (option.quantity / Math.max(...bundleConfig.discount_options.map((opt: any) => opt.quantity))) * 100,
        };
    });

    const bar_foreground_color = bundleConfig?.bundles_design?.progress_bar_color || "#00FFD1";
    const bar_background_color = bundleConfig?.bundles_design?.progress_bar_bg_color || "#484545";

    useEffect(() => {
        const ele: any = document.getElementsByClassName("RSPBprogression");
        if (ele.length > 0) {
            ele[0].style.display = "block";
        }
    }, []);

    const messageBlock = tierSuccessMessage ? (
        <div
            className={`${styles.messageText} `}
            style={{
                color: bundleConfig?.bundles_design?.total_footer_text_color || "#FFFFFF",
                marginBottom: 5,
            }}
            dangerouslySetInnerHTML={{
                __html: tierSuccessMessage,
            }}
        />
    ) : null;

    if (
        actualConfigDiscountType !== DISCOUNT_TYPES.TIER &&
        [BundleTypes.BUNDLE_BUILDER, BundleTypes.BB_PLACEHOLDER].includes(bundleConfig.bundle_type)
    )
        return null;

    if (
        bundleConfig?.tier_discount_basis == "product_based" &&
        [BundleTypes.BUNDLE_BUILDER, BundleTypes.BB_PLACEHOLDER].includes(bundleConfig.bundle_type)
    )
        return null;

    return (
        <>
            {messagePlacement === "top" && messageBlock}

            <span
                className={styles.progressBarMainWrapper}
                style={{
                    position: "relative",
                    transform: "translateX(0%)",
                    minHeight: "35px",
                    display: bundleConfig.show_progress_bar ? "inline-block" : "none",
                }}
            >
                <ProgressBar
                    className={styles.progressBarComponent}
                    percent={Math.floor(progressPercent) || 2}
                    height={6}
                    filledBackground={bar_foreground_color}
                    unfilledBackground={bar_background_color}
                    stepPositions={(() => {
                        // Start from 10% and distribute remaining 90% equally
                        const numberOfTiers = tiers.length;

                        // Special case for 2 tiers: position at 50% and 100%
                        if (numberOfTiers === 2) {
                            return [50, 100];
                        }

                        const startPosition = 10;
                        const availableSpace = 90; // 100% - 10%

                        return tiers.map((_, index) => {
                            if (numberOfTiers === 1) return 100;
                            return startPosition + (availableSpace / (numberOfTiers - 1)) * index;
                        });
                    })()}
                >
                    {[...(tiers || [])]
                        ?.sort((a: any, b: any) => a.count - b.count)
                        .map((tier: any, idx: number) => {
                            const accomplished = compareWith >= tier.count;

                            return (
                                <Step key={idx} transition="scale">
                                    {({ position }: any) => {
                                        return (
                                            <div
                                                className={styles.progressBarStepContainer}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    position: "absolute",
                                                    top: "-20px",
                                                    left: `${position}%`,
                                                    transform: "translateX(-50%)",
                                                }}
                                            >
                                                <RenderProgressIcon
                                                    bar_background_color={bar_background_color}
                                                    bar_foreground_color={bar_foreground_color}
                                                    accomplished={accomplished}
                                                />

                                                {/* Discount label */}
                                                <span
                                                    className={styles.discountLabelWrapper}
                                                    style={{
                                                        marginTop: "4px",
                                                        textAlign: "center",
                                                        fontSize: [
                                                            BundleTypes.MIX_MATCH,
                                                            BundleTypes.MIX_MATCH_SECTIONAL,
                                                        ].includes(bundleConfig?.bundle_type)
                                                            ? bundleConfig?.bundles_design
                                                                  ?.discount_tabs_discount_label_size
                                                            : 12,
                                                        fontWeight: 500,
                                                        lineHeight: "15px",
                                                        width: 90,
                                                        color: [
                                                            BundleTypes.MIX_MATCH,
                                                            BundleTypes.MIX_MATCH_SECTIONAL,
                                                        ].includes(bundleConfig?.bundle_type)
                                                            ? bundleConfig?.bundles_design
                                                                  ?.discount_tabs_quantity_label_color
                                                            : bundleConfig?.bundles_design?.total_footer_text_color ||
                                                              "#FFFFFF",
                                                    }}
                                                >
                                                    <div
                                                        className={styles.discountLabelContent}
                                                        id={`bundle_progress_bar_discount_${idx}`}
                                                        style={{ lineHeight: "normal" }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: getDiscountValueWithSignString(
                                                                tier.discountType,
                                                                tier.discountValue || 0,
                                                                currency,
                                                                money_format,
                                                            ),
                                                        }}
                                                    ></div>
                                                </span>
                                            </div>
                                        );
                                    }}
                                </Step>
                            );
                        })}
                </ProgressBar>
            </span>

            {messagePlacement === "bottom" && messageBlock}
        </>
    );
};

export default BundleProgressBar;
